// Get all elements with the class 'experience-component'
const elements = document.querySelectorAll('.experience-component');
// This code may need revising if placed within a page containing two PD areas separated by other types of content.

let lastChildElement = null;
let shouldAddClass = false;
let lastNonDNoneElement = null;

elements.forEach((element, index) => {
	if (element.classList.contains('experience-layouts-1rowstackable')) {
		lastChildElement = element.querySelector('.pd-l-1rowstackable');

		// Check if pd-l-1rowstackable has overlayonimage-tile-container with no children inside
		const overlayContainer = lastChildElement.querySelector('.overlayonimage-tile-container');
		if (overlayContainer && !overlayContainer.hasChildNodes()) {
			element.classList.add('d-none');

			// Check if there was a previous 'pd-l-1rowstackable' element without 'd-none' class
			if (lastNonDNoneElement) {
				lastNonDNoneElement.classList.add('pb-5', 'mb-2');
				lastNonDNoneElement.classList.remove('pb-lg-2');
			}
		} else {
			// Update the last 'pd-l-1rowstackable' element without 'd-none' class
			lastNonDNoneElement = lastChildElement;
		}

		// Set the flag to add the class
		shouldAddClass = true;
	} else {
		// If it's not an 'experience-layouts-1rowstackable' div, and the flag is set to true, add the class
		if (shouldAddClass && lastChildElement) {
			lastChildElement.classList.add('pb-5', 'mb-2');
			lastChildElement.classList.remove('pb-lg-2');
		}
		// Reset the flag and last child element
		shouldAddClass = false;
		lastChildElement = null;
	}

	// If it's the last element on the page and the flag is set to true, add the class
	if (index === elements.length - 1 && shouldAddClass && lastChildElement) {
		lastChildElement.classList.add('pb-5', 'mb-2');
		lastChildElement.classList.remove('pb-lg-2');
	}
});
